const sendBasketReq = async (data, URL, responseType = 'text') => {
  try {
    window.loaderShow('#basket-container');

    const baseURL = '/local/components/panfilov/sale.basket.basket/ajax.php';
    const rawResponse = await fetch(URL || baseURL, {
      method: 'POST',
      body: data,
    });

    let response = null;
    if (responseType === 'text') {
      response = await rawResponse.text();
    }
    if (responseType === 'json') {
      response = await rawResponse.json();
    }
    return response;
  } catch (err) {
    // eslint-disable-next-line
    console.error(err);

    return null;
  }
};

export default sendBasketReq;
